import { render, staticRenderFns } from "./YjwjText.vue?vue&type=template&id=b0e92ae8&scoped=true&"
import script from "./YjwjText.vue?vue&type=script&lang=js&"
export * from "./YjwjText.vue?vue&type=script&lang=js&"
import style0 from "./YjwjText.vue?vue&type=style&index=0&id=b0e92ae8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e92ae8",
  null
  
)

export default component.exports